module.exports = __webpack_public_path__ + "static/img/fluent-dismiss-circle-24-regular.b2004f97.svg";